// import React, { useState } from "react";
// import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import Test from "./pages/Test";
// import "./App.css";
// import Upload from "./pages/Upload";
// import Search from "./pages/Search";
// import FlashData from "./pages/FlashData";
// import BOM from "./pages/BOM";
// import Binning from "./pages/Binning";
// import Home from "./pages/Home";
// import QualityLoss from "./pages/QualityLoss";
// import ShipmentTracker from "./pages/ShipmentTracker";
// import Sidebar from "./components/Sidebar/Sidebar";
// import Navbar from "./components/Navbar/Navbar";
// import Inspection from "./pages/Inspection";
// import Section1 from "./components/Inspection/Sections/Section1";
// import Section2 from "./components/Inspection/Sections/Section2";
// import Section3 from "./components/Inspection/Sections/Section3";
// import PdiWitness from "./pages/PdiWitness";
// import ViewProjectDetails from "./components/Home/ViewProjectDetails";
// import InspectionForm from "./components/Inspection/InspectionForms";
// import ProcessFlowChart from "./components/Coming Soon Pages/ProcessFlowChart";
// import ManagementSummury from "./components/Coming Soon Pages/ManagementSummury";
// import GraphicalSummary from "./components/Coming Soon Pages/GraphicalSummary";
// import DesignInputs from "./components/Table Wise Scanning/DesignInputs";
// import SiteSupervisorInputs from "./components/Table Wise Scanning/SiteSupervisorInputs.js";
// import SitePlannerTabs from "./components/Table Wise Scanning/Site Planner Tabs/SitePlannerTabs.js";
// import ModuleReconciliation from "./components/Coming Soon Pages/ModuleReconciliation";
// import NonConformance from "./components/Coming Soon Pages/NonConformance";
// import ReleaseNotes from "./pages/ReleaseNotes";
// import { UserProvider } from "./pages/UserContext.js";
// import useAuth from "./pages/keycloak/useAuth.js";

// function App() {
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const { isLogin, isLoading } = useAuth(); // Destructure isLoading from useAuth

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Show a loading spinner while Keycloak is initializing
//   if (isLoading) {
//     return <div>Loading authentication...</div>;
//   }

//   // If not logged in, show an error message or redirect to login
//   if (!isLogin) {
//     return <div>Authentication failed. Please try again.</div>;
//   }

//   // Render the application only if the user is authenticated
//   return (
//     <Router>
//       <Routes>
//         <Route
//           path="*"
//           element={
//             <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
//               <UserProvider>
//                 <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
//                 <div style={{ display: "flex", flex: 1 }}>
//                   <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
//                   <main
//                     style={{
//                       flexGrow: 1,
//                       marginLeft: sidebarOpen ? 300 : 60,
//                       padding: "16px",
//                       overflow: "auto",
//                       width: `calc(100% - ${sidebarOpen ? '300px' : '60px'})`,
//                     }}
//                   >
//                     <Routes>
//                       <Route path="/" element={<Home />} />
//                       <Route path="/test" element={<Test />} />
//                       <Route path="/process-flow-chart" element={<ProcessFlowChart />} />
//                       <Route path="/management-summary" element={<ManagementSummury />} />
//                       <Route path="/graphical-summary" element={<GraphicalSummary />} />
//                       <Route path="/table-wise-scanning/design-inputs" element={<DesignInputs />} />
//                       <Route path="/table-wise-scanning/site-supervisor-inputs" element={<SiteSupervisorInputs />} />
//                       <Route path="/table-wise-scanning/site-planner-inputs" element={<SitePlannerTabs />} />
//                       <Route path="/module-reconciliation-sheet" element={<ModuleReconciliation />} />
//                       <Route path="/ncr" element={<NonConformance />} />
//                       <Route path="/manufacturing-traceability/upload" element={<Upload />} />
//                       <Route path="/manufacturing-traceability/search" element={<Search />} />
//                       <Route path="/manufacturing-traceability/tracking" element={<FlashData />} />
//                       <Route path="/manufacturing-traceability/bom" element={<BOM />} />
//                       <Route path="/manufacturing-traceability/binning" element={<Binning />} />
//                       <Route path="/manufacturing-traceability/quality-loss" element={<QualityLoss />} />
//                       <Route path="/manufacturing-traceability/shipment-tracker" element={<ShipmentTracker />} />
//                       <Route path="/inspections" element={<Inspection />} />
//                       <Route path="/inspections/section1/:formId" element={<Section1 />} />
//                       <Route path="/inspections/section2/:formId" element={<Section2 />} />
//                       <Route path="/inspections/section3/:formId" element={<Section3 />} />
//                       <Route path="/manufacturing-traceability/pdi-witness" element={<PdiWitness />} />
//                       <Route path="/view-project-details/:projectId" element={<ViewProjectDetails />} />
//                       <Route path="/inspections/forms" element={<InspectionForm />} />
//                       <Route path="/releasenotes" element={<ReleaseNotes />} />
//                       {/* Add more routes here */}
//                     </Routes>
//                   </main>
//                 </div>
//               </UserProvider>
//             </div>
//           }
//         />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import Login from "./pages/Login.js";
import Test from "./pages/Test";
import "./App.css"; // Ensure the CSS file is imported
import Upload from "./pages/Upload";
import Search from "./pages/Search";
import FlashData from "./pages/FlashData";
import BOM from "./pages/BOM";
import Binning from "./pages/Binning";
import Home from "./pages/Home";
import QualityLoss from "./pages/QualityLoss";
import ShipmentTracker from "./pages/ShipmentTracker";
import Sidebar from "./components/Sidebar/Sidebar";
import Navbar from "./components/Navbar/Navbar";
import Inspection from "./pages/Inspection";
import Section1 from "./components/Inspection/Sections/Section1";
import Section2 from "./components/Inspection/Sections/Section2";
import Section3 from "./components/Inspection/Sections/Section3";
import PdiWitness from "./pages/PdiWitness";
import ViewProjectDetails from "./components/Home/ViewProjectDetails";
import InspectionForm from "./components/Inspection/InspectionForms";
import ProcessFlowChart from "./components/Coming Soon Pages/ProcessFlowChart";
import ManagementSummury from "./components/Coming Soon Pages/ManagementSummury";
import GraphicalSummary from "./components/QualityInspectionSummary/GraphicalSummary/GraphicalSummary.js";
import DesignInputs from "./components/Table Wise Scanning/DesignInputs";
import SiteSupervisorInputs from "./components/Table Wise Scanning/SiteSupervisorInputs.js";
import SitePlannerTabs from "./components/Table Wise Scanning/Site Planner Tabs/SitePlannerTabs.js";
import ModuleReconciliation from "./components/Coming Soon Pages/ModuleReconciliation";
import NonConformance from "./components/Coming Soon Pages/NonConformance";
import ReleaseNotes from "./pages/ReleaseNotes";
import { UserProvider } from "./pages/UserContext.js";
import ViewInspection from "./components/Inspection/View_Inspection.js";
import QualityPanel from './components/SupportDocuments/QualityPanel/QualityPanel.js';
import EngineeringPanel from './components/SupportDocuments/EngineeringPanel/EngineeringPanel.js';
import ReceivingPanel from './components/SupportDocuments/ReceivingPanel/ReceivingPanel.js';
import OpenForAllPanel from './components/SupportDocuments/OpenForAllPanel/OpenForAllPanel.js';
import ReceivingTabsComponent from "./components/ReceivingModulesManagement/receivingSupplierTabs.js";
import VehicleInspection from "./components/ReceivingModulesManagement/VehicleInspection/VehicleInspection.js";
import ModuleFlaggedForm from "./components/ReceivingModulesManagement/InternalTabs/FlaggedModuleForm.js";
import QualityInspectionSummary from "./components/QualityInspectionSummary/QualityInspectionSummary.js";
import Reconciliation_Dashboard from "./components/ModuleReconciliationSheet/Reconciliation_Dashboard.js";
import DamagedModuleTabsComponent from "./components/ModuleReconciliationSheet/DamageModule/DamageModuleTabs.js";
import ReturnToStoreTabs from "./components/ModuleReconciliationSheet/DamageModule/ReturnToStore/ReturnToStoreTabs.js";
import UncountedModules from "./components/ModuleReconciliationSheet/UncountedModules.js";
import LandingPage from "./components/LandingPage.js";
import TrackerTab from "./components/AutomationReport/Tracker/TrackerTab.js";
import ReportMain from "./components/AutomationReport/ReportGenerator/ReportMain.js";

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isLogin, setIsLogin] = useState(false); // Track login state
  const [isLoading, setIsLoading] = useState(true); // Track loading state

  // Toggle sidebar function
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };



  // Firebase authentication state observer
  useEffect(() => {

    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Optional: Adds smooth scrolling animation
    });

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLogin(true); // User is logged in
      } else {
        setIsLogin(false); // User is logged out
      }
      setIsLoading(false); // Authentication check is complete
    });

    return () => unsubscribe(); // Cleanup observer on unmount
  }, []);

  // Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      setIsLogin(false); // Update login state
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  // Show a loading spinner while Firebase is initializing
  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="loader"></div>
      </div>
    );
  }

  // Render the application
  return (
    <Router>
      <Routes>
        {/* Default route: Redirect to Login if not authenticated */}
        <Route
          path="/"
          element={isLogin ? <Navigate to="/home" /> : <Login />}
        />

        {/* Protected routes: Only accessible if authenticated */}
        {isLogin && (
          <Route
            path="*"
            element={
              <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
                <UserProvider>
                  <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
                  <div style={{ display: "flex", flex: 1 }}>
                    <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
                    <main
                      style={{
                        flexGrow: 1,
                        marginLeft: sidebarOpen ? 300 : 60,
                        padding: "0px 0px 0px 1px",
                        overflow: "auto",
                        width: `calc(100% - ${sidebarOpen ? '300px' : '60px'})`,
                      }}
                    >
                      <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/home" element={<Home />} />
                        <Route path="/test" element={<Test />} />
                        <Route path="/landing-page" element={<LandingPage />} />
                        <Route path="/process-flow-chart" element={<ProcessFlowChart />} />
                        <Route path="/management-summary" element={<ManagementSummury />} />
                        <Route path="/graphical-summary" element={<GraphicalSummary />} />
                        <Route path="/table-wise-scanning/design-inputs" element={<DesignInputs />} />
                        <Route path="/table-wise-scanning/site-supervisor-inputs" element={<SiteSupervisorInputs />} />
                        <Route path="/table-wise-scanning/site-planner-inputs" element={<SitePlannerTabs />} />
                        <Route path="/module-reconciliation-sheet" element={<ModuleReconciliation />} />
                        <Route path="/ncr" element={<NonConformance />} />
                        <Route path="/manufacturing-traceability/upload" element={<Upload />} />
                        <Route path="/manufacturing-traceability/search" element={<Search />} />
                        <Route path="/manufacturing-traceability/tracking" element={<FlashData />} />
                        <Route path="/manufacturing-traceability/bom" element={<BOM />} />
                        <Route path="/manufacturing-traceability/binning" element={<Binning />} />
                        <Route path="/manufacturing-traceability/quality-loss" element={<QualityLoss />} />
                        <Route path="/manufacturing-traceability/shipment-tracker" element={<ShipmentTracker />} />
                        <Route path="/inspections" element={<Inspection />} />
                        <Route path="/inspections/section1/:formId" element={<Section1 />} />
                        <Route path="/inspections/section2/:formId" element={<Section2 />} />
                        <Route path="/inspections/section3/:formId" element={<Section3 />} />
                        <Route path="/manufacturing-traceability/pdi-witness" element={<PdiWitness />} />
                        <Route path="/view-project-details/:projectId" element={<ViewProjectDetails />} />
                        <Route path="/inspections/forms" element={<InspectionForm />} />
                        <Route path="/releasenotes" element={<ReleaseNotes />} />
                        <Route path="/view-inspection" element={<ViewInspection />} />
                        <Route path="/support-documents/quality" element={<QualityPanel />} />
                        <Route path="/support-documents/engineering" element={<EngineeringPanel />} />
                        <Route path="/support-documents/receiving" element={<ReceivingPanel />} />
                        <Route path="/support-documents/open-for-all" element={<OpenForAllPanel />} />
                        <Route path="/receiving-modules" element={<ReceivingTabsComponent />} /> 
                        <Route path="/vehicle-inspection" element={<VehicleInspection />} />
                        <Route path="/module-flagged-form" element={<ModuleFlaggedForm />} />
                        <Route path="/quality-inspection-summary" element={<QualityInspectionSummary />} />
                        <Route path="/module-reconciliation-sheet/module-reconciliation-dashboard" element={<Reconciliation_Dashboard />} />
                        <Route path="/module-reconciliation-sheet/module-reconciliation-damaged" element={<DamagedModuleTabsComponent />} />
                        <Route path="/module-reconciliation-sheet/module-reconciliation-Store" element={<ReturnToStoreTabs />} />
                        <Route path="/module-reconciliation-sheet/module-reconciliation-Unaccounted" element={<UncountedModules />} />
                        <Route path="/automated-report/report-tracker" element={<TrackerTab />} />
                        <Route path="/automated-report/report-form" element={<ReportMain />} />
                        {/* Add more routes here */}
                      </Routes>
                    </main>
                  </div>
                </UserProvider>
              </div>
            }
          />
        )}

        {/* Redirect all other routes to Login if not authenticated */}
        {!isLogin && (
          <Route path="*" element={<Navigate to="/" />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;